import { render } from "./BaseButton.vue?vue&type=template&id=06889ded"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\webDesign\\trello-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__